export default __webpack_public_path__ + "static/media/PrivacyPolicyPage.87eaa1f8.jpeg";